import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';

interface ContactCardsProps {
  email: string;
  phone: string;
  phoneRaw: string;
  address: string;
  whatsappUrl: string;
}

/**
 * R2 - Contact method cards extracted from ContactoPage
 * R3 - Reduces parent complexity and keeps files under 200 LOC
 */
export function ContactCards({
  email,
  phone,
  phoneRaw,
  address,
  whatsappUrl,
}: ContactCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Email */}
      <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-inboca-teal transition-colors">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="h-12 w-12 rounded-lg bg-inboca-teal/10 flex items-center justify-center">
              <FaEnvelope className="h-6 w-6 text-inboca-teal" />
            </div>
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Email</h3>
            <p className="text-gray-600 mb-3">Escríbenos y te responderemos pronto</p>
            <a
              href={`mailto:${email}`}
              className="text-inboca-teal hover:text-inboca-teal/80 font-semibold"
            >
              {email}
            </a>
          </div>
        </div>
      </div>

      {/* Phone */}
      <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-inboca-orange transition-colors">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="h-12 w-12 rounded-lg bg-inboca-orange/10 flex items-center justify-center">
              <FaPhoneAlt className="h-6 w-6 text-inboca-orange" />
            </div>
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Teléfono</h3>
            <p className="text-gray-600 mb-3">Llámanos en horario laboral</p>
            <a
              href={`tel:${phoneRaw}`}
              className="text-inboca-orange hover:text-inboca-orange/80 font-semibold"
            >
              {phone}
            </a>
          </div>
        </div>
      </div>

      {/* WhatsApp */}
      <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-green-500 transition-colors">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="h-12 w-12 rounded-lg bg-green-50 flex items-center justify-center">
              <FaWhatsapp className="h-6 w-6 text-green-600" />
            </div>
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">WhatsApp</h3>
            <p className="text-gray-600 mb-3">Respuesta inmediata</p>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 hover:text-green-700 font-semibold"
            >
              Iniciar chat
            </a>
          </div>
        </div>
      </div>

      {/* Location */}
      <div className="bg-white rounded-xl p-8 border-2 border-gray-200">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="h-12 w-12 rounded-lg bg-gray-100 flex items-center justify-center">
              <FaMapMarkerAlt className="h-6 w-6 text-gray-600" />
            </div>
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Ubicación</h3>
            <p className="text-gray-600 mb-3">Encuéntranos en</p>
            <p className="text-gray-900 font-semibold">
              {address}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
